import {
    addDoc,
    collection,
    doc,
    getDoc,
    getDocs,
    query,
    setDoc,
    where,
    orderBy,
    limit
} from "firebase/firestore";
import {fireStoreDB} from "../../firebase/client-app";
import {Promise} from "bluebird";
import * as _ from "lodash";
import {DATA_LIMIT} from "../constants/pinterest-board.constant";
import {prepareDocumentList, prepareSingleDocument} from "../../firebase/firebase-doc-util";

export {
    addPinterestBoards,
    addSinglePinterestBoard,
    updateSinglePinterestBoard,
    getSinglePinterestBoard,
    getAllPinterestBoards,
    getPinterestBoardForParentProduct,
    searchPinterestBoards,
    searchPinterestBoardsWithSearchCriteria,
}

const collectionName = 'pinterest-boards';
const collectionReference = collection(fireStoreDB, collectionName);

const addPinterestBoards = (pinterestBoards) => {
    return Promise.map(pinterestBoards, async pinterestBoard => {
        await addSinglePinterestBoard(pinterestBoard);
    });
}

const addSinglePinterestBoard = (pinterestBoard) => {
    pinterestBoard.createdAt = new Date();
    pinterestBoard.updatedAt = pinterestBoard.createdAt;
    return addDoc(collectionReference, pinterestBoard);
}

const updateSinglePinterestBoard = (pinterestBoard) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestBoard.id);
    pinterestBoard.updatedAt = new Date();
    return setDoc(documentReference, pinterestBoard);
}

const getSinglePinterestBoard = async (pinterestBoardId) => {
    const documentReference = doc(fireStoreDB, collectionName, pinterestBoardId);
    const pinterestBoardDoc = await getDoc(documentReference);
    return prepareSingleDocument(pinterestBoardDoc);
}

const getAllPinterestBoards = async () => {
    let searchQuery = query(collectionReference);
    const pinterestBoardsResult = await getDocs(searchQuery);
    return prepareDocumentList(pinterestBoardsResult);
}

const getPinterestBoardForParentProduct = async (parentId) => {
    let searchQuery = query(collectionReference);
    searchQuery = query(searchQuery,
        where('parentId', '==', parentId));

    const pinterestBoardResult = await getDocs(searchQuery);
    const pinterestBoardsList = prepareDocumentList(pinterestBoardResult);
    return pinterestBoardsList[0];
}

const searchPinterestBoards = async (searchText, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    searchQuery = query(searchQuery,
        orderBy('updatedAt', 'desc'));

    searchQuery = query(searchQuery, limit(perPage));

    const pinterestBoardResult = await getDocs(searchQuery);
    return prepareDocumentList(pinterestBoardResult);
}

const searchPinterestBoardsWithSearchCriteria = async (searchCriteriaList, perPage = DATA_LIMIT) => {
    let searchQuery = query(collectionReference);

    // console.log('searchPinterestBoardsWithSearchCriteria', {searchCriteriaList});

    _.forEach(searchCriteriaList, searchCriteria => {
        searchQuery = query(searchQuery,
            where(searchCriteria.field, searchCriteria.condition, searchCriteria.value));
    });

    /*if (searchCriteriaList.length === 0) {
        searchQuery = query(searchQuery, orderBy('updatedAt', 'desc'));
    }*/

    searchQuery = query(searchQuery, limit(perPage));

    const pinterestBoardResult = await getDocs(searchQuery);
    return prepareDocumentList(pinterestBoardResult);
}
